import { useSelector } from 'react-redux';
import translation from '../../../../../../../languages';
import './save-label.scss';

type SaveLabelProps = TranslationProps & { saveAmount: string };

const SaveLabel = ({ t, saveAmount }: SaveLabelProps) => {
    const currency = useSelector((state: RootState) => state.main.currency);

    return (
        <span className='save-label'>
            {t('materialPage.sections.partOfBundle.saveLabel')} {saveAmount} {currency.symbol}
        </span>
    );
};

const translate = translation('material-page');

export default translate(SaveLabel);
